PJQ.views.projects.AddParticipantsDetailedModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Modal-Add-Participants-Detailed'),
		minWidth: '90%',
		onSave: null,
		isWrapForm: true,
		wrapFormName: 'modal-add-participants',
		isUseNewAddressBook: false
	},
	events: {
		'click .btn-add-selected': 'addSelected'
	},
	beforeModalCreated: function () {
	},
	renderData: function () {
		return {
			wrapFormName: this.options.wrapFormName,
			isUseNewAddressBook: this.options.isUseNewAddressBook
		};
	},
	beforeRender: function () {

	},
	afterRender: function () {
		if (this.options.isUseNewAddressBook) {
			let projectId = null
			if (this.options.projects) {
				projectId = this.options.projects[0].get('projectId');
			}
			new PJQ.ajax.Request({
				endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
					{
						endpoint: 'projects',
						value: projectId ? projectId : PJQ.app.session.project.get('projectId')
					},
					{
						endpoint: 'pcg'
					}
				])
			}).get().done(_.bind(function (data) {
				if (PJQ.app.session.project) {
					new PJQ.Alert(this.$('.alert-project-name'), {
						type: 'primary',
						text: 'Project Info: ' + PJQ.app.session.project.get('projectName') + ' ' + PJQ.app.session.project.get('city') + ' ' + PJQ.app.session.project.get('state') + ' ' + PJQ.app.session.project.get('zip'),
						extraClasses: ['d-flex', 'text-align-center', 'align-content-center', 'justify-content-center']
					});
				}

				this.addressBookView = new PJQ.views.addressbook.AddressBook({
					el: this.$('.addressbook-container'),
					selectionMode: PJQ.constants.addressBook.selectionMode.ADD_TO_PROJECT,
					disabledContacts: this.options.disableContacts ? this.options.disableContacts : data.contactsNoGroup,
					disabledContactGroups: this.options.isMultipleProjects ? null : data.contactGroups,
					onSelection: _.bind(function (contactsAll, contactsNoGroup, contactGroups) {
						this.$('.btn-add-selected').prop('disabled', (_.size(contactsNoGroup) + _.size(contactGroups)) === 0);
						this.selectedContactsAll = contactsAll;
					}, this)
				});
			}, this)).fail(function () {
				PJQ.notifications.notify.errorNotify({
					message: 'Something went wrong!'
				});
			});
		}
		else {
			window.selectedCompanies = [];
			window.selectedContacts = [];
			window.selectedGroups = [];
			window.selectedContactGroups = [];
			window.pjqSessionId = PJQ.app.session.id;
			window.pjqABContext = 'ap2';
			window.pjqIsAddProjectContacts = false;
			window.isHideMerge = true;
			window.isHideAddSelectedContacts = true;
			window.isHideReturnToProject = true;
			window.isHideImportExport = true;
			window.initAbEditCallback = _.bind(function (isEditing) {
				if (isEditing) {
					this.$('.modal-btn-outer').hide();
				}
				else {
					this.$('.modal-btn-outer').show();
				}
			}, this);

			let $form = this.$("Form[name='" + this.options.wrapFormName + "']");
			window.validator = $form.validate({
				onsubmit: false,
				onkeyup: false,
				showErrors: function showErrors(errorMap, errorList) {
					for (let i = 0; errorList[i]; i++) {
						let element = this.errorList[i].element;
						//solves the problem with brute force
						//remove existing error label and thus force plugin to recreate it
						//recreation == call to error placement function
						this.errorsFor(element).remove();
					}
					this.defaultShowErrors();
				},
				errorPlacement: function errorPlacement(error, element) {
					error.html('<br />' + error.text());
					if (element.attr('tagName') == 'select' || element.hasClass('pjq-numeric-field-width'))
						error.appendTo(element.parent().parent());
					else
						error.appendTo(element.parent());
				},
				errorClass: "pjq-errortext",
				ignore: "pjq-validate-ignore"
			});

			initAddressBook($form);
		}
	},
	addSelected: function () {
		this.selectedContacts = [];
		this.selectedCompanies = [];
		this.selectedGroups = [];

		if (this.options.isUseNewAddressBook) {
			this.selectedContacts = this.addressBookView.selectedContactsNoGroup;
			this.selectedGroups = this.addressBookView.selectedContactGroups;
		}
		else {
			this.selectedContacts = window.selectedContacts;
			this.selectedCompanies = window.selectedCompanies;
			this.selectedGroups = window.selectedGroups;
		}

		if (_.size(this.selectedContacts) + _.size(this.selectedCompanies) + _.size(this.selectedGroups) === 0) {
			PJQ.notifications.notify.errorNotify({
				message: 'No contacts were selected.  Please make selections to continue.'
			});
			return;
		}

		if (_.size(this.selectedContacts) + _.size(this.selectedCompanies) > 3200 || _.size(this.selectedGroups) > 3200) {
			PJQ.notifications.notify.errorNotify({
				message: 'Too many results were selected.  Please refine your search to continue.'
			});
			return;
		}

		if (!this.options.isMultipleProjects) {
			let callback = _.bind(function () {
				new PJQ.ajax.Request({
					endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
						{
							endpoint: 'projects',
							value: PJQ.app.session.project.id
						},
						{
							endpoint: 'addpcg'
						}]),
					data: {
						contactIds: this.selectedContacts,
						contactCompanyIds: this.selectedCompanies,
						contactGroupIds: this.selectedGroups
					}
				}).post().done(_.bind(function (data) {
					if (typeof this.options.onSave === 'function') {
						this.options.onSave(data.contactIds, data.projectContactIds);
					}
					this.removeModal();
				}, this)).fail(function () {
				});
			}, this);

			new PJQ.ajax.Request({
				endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
					{
						endpoint: 'projects',
						value: PJQ.app.session.project.id
					},
					{
						endpoint: 'checkpcg'
					}]),
				data: {
					contactIds: this.selectedContacts,
					contactCompanyIds: this.selectedCompanies,
					contactGroupIds: this.selectedGroups
				}
			}).post().done(_.bind(function (data) {
				if (data.results.length > 0) {
					new PJQ.views.projects.AddParticipantsErrorModal({
						data: data.results,
						contactIds: this.selectedContacts,
						contactCompanyIds: this.selectedCompanies,
						contactGroupIds: this.selectedGroups,
						onContinue: _.bind(function () {
							callback();
						}, this)
					});
				}
				else
					callback();

			}, this)).fail(function () {
			});
		}
		else {
			this.options.onSave(this.selectedContactsAll, {
				selectedContacts: this.selectedContacts,
				selectedCompanies: this.selectedCompanies,
				selectedGroups: this.selectedGroups
			});
			this.removeModal();
		}
	}
});

PJQ.views.projects.AddParticipantsErrorModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Modal-Add-Participants-Error-List'),
		minWidth: '90%',
		data: null,
		onContinue: _.noop
	},
	events: {
		'click .btn-copy-phone': 'copyPhone',
		'click .btn-continue': 'continue',
		'click .export': 'export'
	},
	afterRender: function () {
		new PJQ.views.dataTables.DataTable({
			el: this.$('.participant-errors'),
			pageLength: 999999,
			isHideSearch: true,
			data: this.options.data,
			dom: 't',
			order: [],
			columns: [
				{
					"data": "companyName",
					"title": "Company",
					"orderable": false
				},
				{
					"data": "contactName",
					"title": "Contact",
					"orderable": false
				},
				{
					"data": "phone",
					"title": "Phone",
					"orderable": false,
					"render": _.bind(function (data, type, row) {
						let html = '<div style="min-width:100px;" class="d-flex align-items-center">',
							phoneFormatted = row.phone ? (PJQ.helpers.formatHelpers.formatPhoneNumber(row.phone) + (_.size(row.phoneExtension) === 0 ? '' : ' x' + row.phoneExtension)) : 'N/A';

						if (row.phone !== '')
							html += '<button type="button" class="btn btn-transparent-dark btn-copy-phone" title="Copy Phone #" data-phone="' + phoneFormatted + '"><i class="far fa-phone text-dark"></i></button>';

						html += '<div class="flex-fill ' + (row.phone ? '' : 'text-muted') + '">' + phoneFormatted + '</div>';
						html += '</div>';
						return html;
					}, this)
				},
				{
					"data": "email",
					"title": "Email",
					"orderable": false
				},
				{
					"data": "reason",
					"title": "Reason",
					"orderable": false
				}
			]
		});

	},
	continue: function () {
		if (typeof this.options.onContinue === 'function')
			this.options.onContinue();

		this.removeModal();
	},
	export: function () {

		new PJQ.ajax.Request({
			endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'projects',
					value: PJQ.app.session.project.id
				},
				{
					endpoint: 'checkpcg'
				},
				{
					endpoint: 'export'
				}
			]),
			data: {
				contactIds: this.options.contactIds,
				contactCompanyIds: this.options.contactCompanyIds,
				contactGroupIds: this.options.contactGroupIds
			}
		}).post().success(_.bind(function (data) {
			PJQ.files.downloadFile(data.url, {isEndpoint: false});
		}, this));
	},
	copyPhone: function (e) {
		let inputId = 'h_input_' + _.uniqueId(),
			hiddenInput = $('<input>', {
				value: $(e.currentTarget).data('phone'),
				style: 'position: absolute;left:-2000px;top:-2000px',
				id: inputId
			});
		this.$el.append(hiddenInput);
		hiddenInput[0].select();
		document.execCommand("copy");
		hiddenInput.remove();
		PJQ.notifications.notify.successNotify({
			message: 'Number copied to clipboard.'
		});
	}
});
